import type {BaseItem} from './BaseItem';
import type {EntitlementsModules} from './Entitlement';

export enum ConfigKey {
  SHIFT_HOUR_START = 'SHIFT_HOUR_START',
  EMPLOYEE_SHIFT_DURATION_HOURS = 'EMPLOYEE_SHIFT_DURATION_HOURS',
  FORCE_EMPLOYEE_WORK_TIME_TRACKING = 'FORCE_EMPLOYEE_WORK_TIME_TRACKING',
  EMPLOYEE_AUTO_LOGOUT_TIME = 'EMPLOYEE_AUTO_LOGOUT_TIME',
  ADMIN_AUTO_LOGOUT_TIME = 'ADMIN_AUTO_LOGOUT_TIME',
  ANNOUNCE_RESIDENT_BIRTHDAY = 'ANNOUNCE_RESIDENT_BIRTHDAY',
  FORCE_IP_CHECK_FOR_PAIRED_DEVICE = 'FORCE_IP_CHECK_FOR_PAIRED_DEVICE',

  // FACILITY DETAILS
  ALLOW_FILES_UPLOAD_FOR_CONTACT_PERSON = 'ALLOW_FILES_UPLOAD_FOR_CONTACT_PERSON',
  CARE_FACILITY_NAME = 'CARE_FACILITY_NAME',
  CARE_FACILITY_ADDRESS = 'CARE_FACILITY_ADDRESS',
  CARE_FACILITY_PHONE_NUMBER = 'CARE_FACILITY_PHONE_NUMBER',
  CARE_FACILITY_EMAIL = 'CARE_FACILITY_EMAIL',
  CARE_FACILITY_LOGO = 'CARE_FACILITY_LOGO',
}

export const ConfigGroups = {
  GENERAL: 'GENERAL',
  CARE_FACILITY_DETAILS: 'CARE_FACILITY_DETAILS',
};

export enum ConfigRegexValidation {
  NUMBERS_0_TO_23 = '^([0-9]|1[0-9]|2[0-3])$',
  NUMBERS_1_TO_24 = '^([1-9]|1[0-9]|2[0-4])$',
  PHONE_NUMBER_OR_EMPTY = '^(\\+\\d{10,12}|)$',
  POSITIVE_NUMBERS = '^[1-9]\\d{0,2}$',
  BOOLEAN = '^(true|false)$',
  IMAGE_FILE_NAME = '^(.+\\.(png|jpg|jpeg|svg|bmp)|)$',
  EMAIL = '^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+.[A-Za-z]{2,}$',
  ANY_OR_EMPTY = '^(.*|)$',
}

export interface InitialConfig {
  key: string;
  group: string;
  label: {
    pl: string;
    en: string;
    de: string;
    uk: string;
  };
  value: ConfigValue;
  description: {
    pl: string;
    en: string;
    de: string;
    uk: string;
  };
  dataType: DataType;
  regex: string;
  requiredEntitlement?: EntitlementsModules;
}

export type Config = BaseItem & InitialConfig;

export type ConfigValue = {
  stringValue?: string;
  numberValue?: number;
  boolValue?: boolean;
};

export enum DataType {
  STRING = 'STRING',
  NUMBER = 'NUMBER',
  BOOLEAN = 'BOOLEAN',
  PUBLIC_IMAGE = 'PUBLIC_IMAGE',
}
